// extracted by mini-css-extract-plugin
export default {"solidyellow":"BrandButton_solidyellow__yygQ3","solidblue":"BrandButton_solidblue__gek6I"};